<ms-event-pick
    class="result"
    *ngFor="let option of activeMarket.options; trackBy: optionsTrackBy"
    [option]="option"
    [event]="event"
    [optionGroup]="activeMarket"
    [trackingSource]="tracking.source"
    [trackingGameDetails]="tracking.gameDetails"
    [enableOptionIndicator]="false">
    <ms-tree-option class="card-option" [option]="option" />
</ms-event-pick>
